module.exports = __webpack_public_path__ + "img/20190529110637微信截图_20190529110855.4d630cae.png";